const siteUtils = {
  /**
   * Returns a powr site code by converting given string to lowercase, removing all non-alphanumeric chars etc.
   * @param val String to transform
   * @returns valid powr site code
   */
  getSiteCode: (val: string) => {
    if (val == null) {
      return null;
    }
    // POWR Site Code can only contain letters (a-z), digits (0-9), and hyphens (-), but cannot start or end with a hyphen
    const siteCode = val
      .trim()
      .toLowerCase()
      .replace(/\\s/g, '-') // replace all whitespace character with hyphens
      .replace(/[^a-z0-9-]/gi, '') // remove any character not alphanumeric
      .substring(0, 64); // only 64 characters
    return siteCode;
  },

  validateSiteCode: (powrSiteCode: string) => {
    const powrSiteCodeRegex = /^(?!-)[a-z0-9-]{1,63}(?<!-)$/;

    if (!powrSiteCodeRegex.test(powrSiteCode)) {
      return false;
    }
    return true;
  },
};

export { siteUtils };
